import { scaleType, configType } from "../../types";
export const createPlotClassName = (
  scales: scaleType[],
  config: configType,
) => {
  return (
    scales
      .map((scale) => `${scale.dataMapping}-${scale.type}`)
      .sort()
      .join("_") + `id${config?.plotId}${config?.inModal ? "-modal" : ""}`
  );
};
